import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { loginRequest } from "../../../../authConfig";
import { setSelectedServer as setGlobalSelectedServer, getSelectedServer } from "../../../../service/apiServerStore";

const ApiSelector = () => {
  const { instance, accounts } = useMsal();
  const [apiServers, setApiServers] = useState<string[]>([]);
  const [selectedServer, setSelectedServer] = useState<string | null>(getSelectedServer());

  useEffect(() => {
    const loadProfile = async () => {
      if (!accounts.length) return;

      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        const res = await fetch("https://graph.microsoft.com/v1.0/me", {
          headers: { Authorization: `Bearer ${response.accessToken}` },
        });

        if (!res.ok)
          throw new Error(`Graph request failed: ${res.status}`);
        const data = await res.json();

        const apiServerList = data.officeLocation?.split(";") || ["api"];
        const urls = apiServerList.map((server: string) => {
          const trimmed = server.trim();
          return (trimmed === "localhost" || trimmed === "127.0.0.1")
            ? `http://${trimmed}`
            : `https://${trimmed}.starsubtera.tech`;
        });

        setApiServers(urls);

        // Keep stored selection if still valid
        const stored = getSelectedServer();
        const initial = urls.includes(stored) ? stored : urls[0] || null;
        setSelectedServer(initial);
        setGlobalSelectedServer(initial);
      } catch (err) {
        console.error("Failed to load user profile:", err);
      }
    };

    loadProfile();
  }, [accounts, instance]);

  if (apiServers.length <= 1)
    return null;

  return (
    <div className="api-selector">
      <label htmlFor="apiSelect">API Server:</label>
      <select
        id="apiSelect"
        value={selectedServer ?? ""}
        onChange={(e) => {
          setSelectedServer(e.target.value);
          setGlobalSelectedServer(e.target.value);
          window.location.reload();
        }}
      >
        {apiServers.map((url) => (
          <option key={url} value={url}>
            {url}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ApiSelector;
